import PropTypes from 'prop-types';

export const SunburstNodeType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.number,
    color: PropTypes.string,
    ringIndex: PropTypes.number.isRequired,
});
